/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author IshakaW
 * 02/15/2022
 *
 */

import React from 'react';
import '../../form-elements/formElement.css';
import EventEmitter from "../../../../../eventEmmiters/EventEmitter";
import FormElementGenerator from "../../form-elements/formElementGenerator";


class AuditForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tpiAuditParam: '',

            errors: {},

            // form fields
            fields: [
                {
                    inputType: 'tpiAuditText',
                    labelName: 'Params',
                    inputName: 'tpiAuditParam',
                    optionValueName: 'tpiAuditParam',
                    optionLabelName: 'tpiAuditParam',
                    placeholder: 'Please enter the parameters here',
                    required: false,
                    disabled: false
                }
            ]
        };
        EventEmitter.emit('setPageHeaderData', {
            page: 'audit',
            pageName: "Audit",
            pageLink: process.env.REACT_APP_BASE_URL + "/#/home/audit",
            optionalIcons: ['manageColumnsIcon']
        });
    }

    /**
     * update the state when user inout a value
     * @param event
     */
    handleChange = event => {
        if (event.optionValueName !== undefined) {
            this.setState({
                [event.optionLabelName]: event.label,
                [event.optionValueName]: event.value
            });
        } else {
            const key = event.currentTarget.name;
            const val = event.currentTarget.value;

            this.setState({
                [key]: val
            });
        }
    };

    loadFilteredResults = () => {
        // publish the tpiAuditParam to the table component
        EventEmitter.emit('tableFilterUrl', {'tpiAuditParam': this.state.tpiAuditParam})
        EventEmitter.emit('openNav', '')
    };

    clearFilteredResults = () => {
        const newState = Object.assign({}, this.state);
        newState.tpiAuditParam = '';

        newState.errors = {};

        this.setState(newState);

        EventEmitter.emit('tableFilterUrl', '')
        EventEmitter.emit('openNav', '')
    };

    /**
     * fire alert
     * @param alertType
     * @param alertTitle
     * @param alertMessage
     */
    setAlert = (alertType, alertTitle, alertMessage) => {
        EventEmitter.emit('setAlert', {
            openAlert: true,
            type: alertType,
            isDisplayAlertIcon: true,
            alertMessage: alertMessage,
            alertTitle: alertTitle
        });
    };

    render() {
        return(
            <div className="view-audit-filter-container">
                <form>
                    <FormElementGenerator currentState={this.state} handleChange={this.handleChange} />
                </form>
                <div className="view-audit-filter-button-container">
                    <input type="button" className="view-audit-filter-cancel" value="Clear"
                           onClick={() => this.clearFilteredResults()} />
                    <input type="button" className="view-audit-filter-submit" value="Search"
                           onClick={() => this.loadFilteredResults()}/>
                </div>
            </div>
        )
    }
}

export default AuditForm;
